import React, { useEffect, useState } from 'react'
import { DataTable, exportToCSV } from '@operations/shared';
import { Button } from "antd";
import { useSelector } from 'react-redux';
import { ITable } from '../../utils/commonInterfaces';
import moment from 'moment';
const AccountEntriesView = () => {
    const tableData = useSelector((state: any) => state.actionsReducer.accountEntriesData);
    const dateRange = useSelector((state: any) => state.actionsReducer.dateRange);
    const formatDate = `AccEntries${moment(dateRange.startDate).format('DMMMYYYY')}-${moment(dateRange.endDate).format('DMMMYYYY')}`
    const [AccountEntries, setAccountEntries] = useState<ITable>({
        data: [],
        columns: [],
        loading: true,
        total: 0,
        currentPage: 1,
        perPage: 10,
    });
    const tableHeaderConverter = (data: any[]) => {
        if (data.length === 0) return [];
        
        return Object.keys(data[0]).map((key) => ({
            title: key.charAt(0).toUpperCase() + key.slice(1),
            dataIndex: key,
            key: key,
        }));
    };
    const data = tableData
    useEffect(() => {
        if (data) {
            setAccountEntries({
                data,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false,
                total: data.length,
                currentPage: 1,
                perPage: 10
            })
        }
    }, [data]);
    return (
        <div className='accountEntriesView'>
            <div className='accountEntriesViewHeader'>
                <Button
                    style={{ color: "#357C3C", borderColor: "#357C3C" ,paddingLeft:"30px", paddingRight:"30px" }}
                    onClick={() => exportToCSV(
                        AccountEntries?.data?.map(item => ({
                            ...item
                        })), 
                        formatDate
                    )}
                >
                    Download
                </Button>
            </div>
            <DataTable
                columns={AccountEntries?.columns}
                rows={AccountEntries?.data}
                handleTableChange={() => { }}
                pagination={false}
                loading={false}
                scrolling={{ x: 'max-content' }}
            />
        </div>
    )
}

export default AccountEntriesView